"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var d3 = _interopRequireWildcard(require("d3"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scaleMin(scale) {
  return scale(d3.min(scale.domain()));
}

function scaleMax(scale) {
  return scale(d3.max(scale.domain()));
}

var Axis = function Axis(_ref) {
  var theme = _ref.theme,
      inverted = _ref.inverted,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      horizontal = _ref.horizontal;
  var origin = {
    x: scaleMin(xScale),
    y: scaleMin(yScale)
  };
  var end = {
    x: horizontal ? scaleMax(xScale) : scaleMin(xScale),
    y: horizontal ? scaleMin(yScale) : scaleMax(yScale)
  };
  var mainPath = "M".concat(origin.x, ",").concat(origin.y, " L").concat(end.x, ",").concat(end.y);
  var tipWidth = 4;
  var tipDeltaX = horizontal ? 0 : tipWidth;
  var tipDeltaY = horizontal ? tipWidth : 0;
  var tipEdge1 = {
    x: end.x + tipDeltaX,
    y: end.y + tipDeltaY
  };
  var tipEdge2 = {
    x: end.x - tipDeltaX,
    y: end.y - tipDeltaY
  };
  var tip1Path = "M".concat(end.x, ",").concat(end.y, " L").concat(tipEdge1.x, ",").concat(tipEdge1.y);
  var tip2Path = "M".concat(end.x, ",").concat(end.y, " L").concat(tipEdge2.x, ",").concat(tipEdge2.y);
  var color = inverted ? theme.inverted.one[1] : theme.one[0];
  return /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: mainPath,
    stroke: color,
    strokeOpacity: "0.4",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: tip1Path,
    stroke: color,
    strokeOpacity: "0.4",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: tip2Path,
    stroke: color,
    strokeOpacity: "0.4",
    strokeWidth: "2"
  }));
};

Axis.propTypes = {
  xScale: _propTypes.default.func.isRequired,
  yScale: _propTypes.default.func.isRequired,
  horizontal: _propTypes.default.bool
};
Axis.defaultProps = {
  horizontal: false
};

var _default = (0, _styledComponents.withTheme)(Axis);

exports.default = _default;
//# sourceMappingURL=Axis.js.map